import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "", enum: "NONE" },
  { value: 2, text: "Box", enum: "BOX" },
  { value: 3, text: "Pcs", enum: "PIECE" },
]);
